define('modules/form_editor/views/main',['require','exports','module','backbone','env','base/vent','../models/form','common/views/modal_layout','./toolbar','./field_editor','./preview_form','common/models/appstate','./notice_view','./code_popup','i18n','../models/check_radio_option','lib/util','ldsh!../templates/layout'],function (require, exports, module) {
  'use strict';
  var Backbone = require('backbone'),
    config = require('env'),
    Vent = require('base/vent'),
    FormModel = require('../models/form'),
    Layout = require('common/views/modal_layout'),
    ToolbarView = require('./toolbar'),
    EditorView = require('./field_editor'),
    FormPreview = require('./preview_form'),
    AppState = require('common/models/appstate'),
    NoticeView = require('./notice_view'),
    CodePopup = require('./code_popup'),
    i18n = require('i18n'),
    CheckGroupOption = require('../models/check_radio_option'),
    util = require('lib/util');

  var Controller = {
    onActiveItemChange: function (fieldModel) {
      //this one comes from the Form model
      //tell the editor to edit this field
      // this event will be fired on method onPreviewSelectedChange above
      // leading to a double component rendering
      //this.vent.trigger("edit:field", fieldModel);
      //tell the preview to highlight this field
      this.vent.trigger('select:element', fieldModel);
    },

    onPreviewSelectedChange: function (fieldModel) {
      //this one comes from View components
      this.model.selectItem(fieldModel);
      this.vent.trigger('edit:field', fieldModel);
    },

    onFormSave: function () {
      //remove mini toolbars
      this.previewView.$el.find('.ed-item-toolbar').remove();
      //remove form-editor classes
      this.previewView.$el
        .find('.ed-panel-item')
        .removeClass('ed-panel-item')
        .addClass('editor-form-group')
        .addClass('form-group');
      //hidden fields
      //first remove the preview items
      this.previewView.$el.find('div.input-hidden').remove();
      _.each(
        this.model.fields.where({ name: 'input:hidden' }),
        function (field) {
          //add hidden field
          var $hiddenField = $('<input />')
            .attr('type', 'hidden')
            .attr('name', field.get('nameAttr'))
            .attr('value', field.get('value'))
            .attr('data-querymap', field.get('variable'))
            .attr('data-fb-login', field.get('socialBinding'))
            .attr('id', field.get('elementId'));

          this.previewView.$('form').append($hiddenField);
        },
        this
      );

      this.trigger('form:save', this.getDataToSave());
      _.delay(
        _.bind(function () {
          //deselect any item that was selected
          this.model.selectItem(null);
          this.hide();
        }, this),
        2000
      );
    },

    getDataToSave: function () {
      var dataToSave = {
        model: this.model.toJSON(),
        content: this.previewView.$el.html(),
        fields: this.model.fields.pluck('labelText'),
      };

      dataToSave.model.fields = dataToSave.model.fields.map(function (field) {
        var currentNameAttr = field.nameAttr || '';
        field.nameAttr = util.sanitizeString(currentNameAttr);

        if (field.name === 'input:hidden') {
          field.isRequired = false;
        }

        return field;
      });

      return dataToSave;
    },

    onFormMoveUp: function () {
      this.model.moveUpField();
    },

    onFormMoveDown: function () {
      this.model.moveDownField();
    },

    onFormDuplicate: function () {
      this.model.duplicateField();
    },

    onFormRemove: function () {
      if (config.avoidConfirmMessages) {
        this.model.removeField();

        return true;
      }

      var deleteText = i18n.t('formEditor.confirmDelete');
      var result = window.confirm(deleteText);
      if (result) {
        this.model.removeField();
        //this.vent.trigger("form:remove");
      }
    },

    onFormAddInput: function () {
      this.model.addField('input:text', { labelText: this.i18n.labelTextLocalized });
    },

    onFormAddAddTextArea: function () {
      this.model.addField('input:textarea', { labelText: this.i18n.labelTextLocalized });
    },

    onFormAddCheckboxGroup: function () {
      this.model.addField('input:checkgroup', { labelText: this.i18n.labelTextLocalized });
    },

    onFormAddRadioButtonGroup: function () {
      this.model.addField('input:radiogroup', { labelText: this.i18n.labelTextLocalized });
    },

    onFormAddDropDown: function () {
      this.model.addField('input:dropdown', { labelText: this.i18n.labelTextLocalized });
    },

    onFormAddHiddenField: function () {
      this.model.addField('input:hidden', { labelText: this.i18n.hiddenTextLocalized });
    },

    onFormAddTermsField: function () {
      var pageId = this.editorView.options.pages_id,
        termsText = this.i18n.termsDefaultText;

      AppState.isCorreoDirectActive(pageId)
        .done(
          _.bind(function (response) {
            if (response.active) termsText = this.i18n.partnersDefaultText;
          }, this)
        )
        .always(
          _.bind(function () {
            this.model.addField('custom:terms', {
              labelText: this.i18n.labelTextLocalized,
              termsText: termsText,
            });
          }, this)
        );
    },

    onFormAddPrivacyField: function () {
      var items = [
        new CheckGroupOption({
          text: i18n.t('formEditor.customTreatmentTerms'),
          isItemRequired: true,
        }),
        new CheckGroupOption({ text: i18n.t('formEditor.customTreatmentEmail') }),
        new CheckGroupOption({ text: i18n.t('formEditor.customTreatmentPostMail') }),
        new CheckGroupOption({
          text: i18n.t('formEditor.customTreatmentPersonalizedOnlineAdvertising'),
        }),
      ];
      this.model.addField('custom:privacy', {
        labelText: this.i18n.labelTextLocalized,
        items: items,
        informationText: i18n.t('formEditor.privacyInformationDefaultText'),
      });
    },

    onFormAddTelephoneField: function () {
      this.model.addField('custom:telephone', { labelText: this.i18n.labelTextLocalized });
    },

    onFormAddEmailField: function () {
      this.model.addField('custom:email', { labelText: this.i18n.labelTextLocalized });
    },

    onFormAddDateDropDown: function () {
      var field = util.isPlatformAMP(this) ? 'custom:date_amp' : 'custom:date';
      this.model.addField(field, { labelText: this.i18n.labelDateLocalized });
    },

    onFormAddGenderDropDown: function () {
      this.model.addField('custom:gender', { labelText: this.i18n.labelTextLocalized });
    },

    onFormAddPasswordField: function () {
      this.model.addField('custom:password', { labelText: this.i18n.labelTextLocalized });
    },

    onFormAddIBANField: function () {
      this.model.addField('custom:iban', { labelText: this.i18n.labelTextLocalized });
    },

    onFormAddDayDropDown: function () {
      this.model.addField('custom:day', { labelText: this.i18n.labelTextLocalized });
    },

    onFormAddMonthDropDown: function () {
      this.model.addField('custom:month', { labelText: this.i18n.labelTextLocalized });
    },

    onFormAddYearDropDown: function () {
      this.model.addField('custom:year', { labelText: this.i18n.labelTextLocalized });
    },

    onFormAddFBLoginButton: function () {
      if (this.model.hasFacebookLogin()) return;
      var pos = this.model.getSocialLoginOrder();
      this.model.addField(
        'custom:login:facebook',
        { labelText: this.i18n.labelTextLocalized },
        { at: pos, silent: true }
      );
      this.showNotice({
        title: this.i18n.noticeTitleFacebookLogin,
        message: this.i18n.noticeMessageFacebookLogin,
      });
    },

    onFormAddLinkedInLoginButton: function () {
      if (this.model.hasLinkedInLogin()) return;
      var pos = this.model.getSocialLoginOrder();
      this.model.addField(
        'custom:login:linkedin',
        { labelText: this.i18n.labelTextLocalized },
        { at: pos, silent: true }
      );
      this.showNotice({
        title: this.i18n.noticeTitleLinkedinLogin,
        message: this.i18n.noticeMessageLinkedinLogin,
      });
    },

    onFormAddGoogleReCaptcha: function () {
      if (this.model.hasGoogleReCaptcha()) return;

      this.model.addField('custom:captcha:google_recaptcha', {
        labelText: this.i18n.labelTextLocalized,
      });
    },

    onFormAddSeparator: function () {
      this.model.addField('custom:separator', { labelText: this.i18n.labelTextLocalized });
    },

    onShowAdvancedMode: function (isShown) {
      this.model.set('isAdvancedMode', isShown || !this.model.get('isAdvancedMode'));
    },
  };

  module.exports = Layout.extend({
    bodyClasses: ['editor', 'modal-open'],
    regions: {
      toolbar: '.js-toolbar',
      editor: '.js-editor',
      preview: '.js-preview',
    },
    template: require('ldsh!../templates/layout'),
    className: 'ed-overlay ed-form-editor',

    events: {
      'click .js-close': 'closeEditor',
      'click .js-close-notice': 'closeNotice',
      'click .js-code': 'openCodePopup',
    },

    initialize: function () {
      this.vent = new Vent();
      this.toolbarView = new ToolbarView({ vent: this.vent });
      this.editorView = new EditorView({ vent: this.vent, options: this.options });
      this.regions.toolbar.show(this.toolbarView);
      this.regions.editor.show(this.editorView);

      this._setupModelDependants();

      this._getLocalDefaultValues();
      this._addVentListeners();
      this._addModelListeners();
      this._selectFirstElement();
    },

    _addVentListeners: function () {
      this.listenTo(this.vent, 'select:element', this.onPreviewSelectedChange);
      this.listenTo(this.vent, 'form:save', this.onFormSave);
      this.listenTo(this.vent, 'form:moveUp', this.onFormMoveUp);
      this.listenTo(this.vent, 'form:moveDown', this.onFormMoveDown);
      this.listenTo(this.vent, 'form:duplicate', this.onFormDuplicate);
      this.listenTo(this.vent, 'form:remove', this.onFormRemove);
      this.listenTo(this.vent, 'form:addTextInput', this.onFormAddInput);
      this.listenTo(this.vent, 'form:addTextArea', this.onFormAddAddTextArea);
      this.listenTo(this.vent, 'form:addCheckboxGroup', this.onFormAddCheckboxGroup);
      this.listenTo(this.vent, 'form:addRadioButtonGroup', this.onFormAddRadioButtonGroup);
      this.listenTo(this.vent, 'form:addDropDown', this.onFormAddDropDown);
      this.listenTo(this.vent, 'form:addHiddenField', this.onFormAddHiddenField);
      this.listenTo(this.vent, 'form:addTermsField', this.onFormAddTermsField);
      this.listenTo(this.vent, 'form:addPrivacyField', this.onFormAddPrivacyField);
      this.listenTo(this.vent, 'form:addTelephoneField', this.onFormAddTelephoneField);
      this.listenTo(this.vent, 'form:addEmailField', this.onFormAddEmailField);
      this.listenTo(this.vent, 'form:addDateDropDown', this.onFormAddDateDropDown);
      this.listenTo(this.vent, 'form:addGenderDropDown', this.onFormAddGenderDropDown);
      this.listenTo(this.vent, 'form:addPasswordField', this.onFormAddPasswordField);
      this.listenTo(this.vent, 'form:addIBANField', this.onFormAddIBANField);
      this.listenTo(this.vent, 'form:addDayDropDown', this.onFormAddDayDropDown);
      this.listenTo(this.vent, 'form:addMonthDropDown', this.onFormAddMonthDropDown);
      this.listenTo(this.vent, 'form:addYearDropDown', this.onFormAddYearDropDown);
      this.listenTo(this.vent, 'form:addFBLoginButton', this.onFormAddFBLoginButton);
      this.listenTo(this.vent, 'form:addLinkedInLoginButton', this.onFormAddLinkedInLoginButton);
      this.listenTo(this.vent, 'form:addGoogleReCaptcha', this.onFormAddGoogleReCaptcha);
      this.listenTo(this.vent, 'form:addSeparator', this.onFormAddSeparator);
      this.listenTo(this.vent, 'form:showAdvancedMode', this.onShowAdvancedMode);
    },

    _addModelListeners: function () {
      this.listenTo(this.model, 'active:item:change', this.onActiveItemChange);
    },

    _setupModelDependants: function (newModel) {
      if (newModel) {
        this.stopListening(this.model);
        this.regions.preview.close();
        this.model = newModel;
      }
      this.model.vent = this.vent;
      this.previewView = new FormPreview({
        vent: this.vent,
        collection: this.model.fields,
        activeItem: this.model.activeItemState,
      });
      this.regions.preview.show(this.previewView);
      this._addModelListeners();
    },

    _getLocalDefaultValues: function () {
      //localized ui, this must be done in the view where we have i18n
      this.i18n = {
        labelTextLocalized: i18n.t('formEditor.label'),
        hiddenTextLocalized: i18n.t('formEditor.hiddenField'),
        labelDateLocalized: i18n.t('formEditor.dateLabel'),
        labelPrivacyLocalized: i18n.t('formEditor.privacyLabel'),
        dateLabelTextLocalized: i18n.t('formEditor.dateLabel'),
        termsDefaultText: i18n.t('formEditor.termsDefaultText'),
        partnersDefaultText: i18n.t('formEditor.partnersDefaultText'),
        noticeTitleFacebookLogin: i18n.t('formEditor.notices.fb.title'),
        noticeMessageFacebookLogin: i18n.t('formEditor.notices.fb.message'),
        noticeTitleLinkedinLogin: i18n.t('formEditor.notices.lin.title'),
        noticeMessageLinkedinLogin: i18n.t('formEditor.notices.lin.message'),
      };
    },

    _selectFirstElement: function () {
      if (this.model.fields.length) {
        this.model.activeItemState.set('item', this.model.fields.first());
      }
    },

    closeEditor: function (e) {
      var confirmationMessage = $.i18n.t('formEditor.confirmClose');
      if (config.avoidConfirmMessages) {
        this.trigger('modal:hide');

        return true;
      }

      if (window.confirm(confirmationMessage)) {
        this.trigger('modal:hide');
      } else {
        // Bootsrap class "close" will handle the action anyway unless we stop it
        e.stopPropagation();
      }
    },

    openCodePopup: function (data) {
      CodePopup.show(this.model, data).then(
        function (newModelString) {
          try {
            var newModelJSON = JSON.parse(newModelString),
              formModel = new FormModel(this.omitSomeProperties(newModelJSON));
            this._setupModelDependants(formModel);
            this._selectFirstElement();
          } catch (e) {
            this.openCodePopup({ error: true });
          }
        }.bind(this)
      );
    },

    omitSomeProperties: function (json) {
      var properties = json.properties,
        geometryProperties = _.find(properties, { name: 'form:geometry' }),
        submitFormatProperties = _.find(properties, { name: 'form:submitFormat' });
      delete geometryProperties.top;
      delete geometryProperties.left;
      delete submitFormatProperties.align;
      return json;
    },

    showNotice: function (options) {
      options = options || {};
      var notice = new NoticeView(options);
      $('.js-notice').append(notice.render().$el);
    },
    onRender: function () {
      this.$el.i18n();
    },
  });

  _.extend(module.exports.prototype, Controller);
});

